import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { AnimatedMessaging } from '../animation/MessagingAnimations';
import { BaseMessageCaption } from './BaseMessageCaption';
import { getMessage } from './MESSAGE';
import styled from 'styled-components';
import { devices } from '../styles/viewports.styles';
const GridImages = styled.div.withConfig({
  displayName: "GridImagesCaption__GridImages",
  componentId: "sc-1hvs74f-0"
})(["display:grid;grid-template-columns:repeat(2,1fr);grid-row-gap:30px;align-items:center;max-width:375px;justify-content:center;@media ", "{grid-column-gap:0;grid-row-gap:0;}"], devices.desktop);
const GridImage = styled.img.withConfig({
  displayName: "GridImagesCaption__GridImage",
  componentId: "sc-1hvs74f-1"
})(["position:relative;object-fit:contain;max-width:70%;max-height:45px;margin:1rem auto;"]);
export const GridImagesCaption = ({
  messageKey
}) => {
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const {
    imageArray = []
  } = getMessage(messageKey); // Create a mapped version of the images array to control
  // the loading process on all images at once

  const imageLoadingArray = imageArray.map(image => Object.assign({}, image, {
    loaded: false
  }));

  const handleImageLoaded = imageIndex => {
    return () => {
      imageLoadingArray[imageIndex].loaded = true; // Check all mapped values, if all images are loaded we change
      // the state value to true and this will trigger animation on
      // the component AnimatedMessaging

      setImagesLoaded(imageLoadingArray.every(image => image.loaded));
    };
  };

  const getGrid = () => {
    return /*#__PURE__*/_jsx(GridImages, {
      children: imageArray.map((imageObj, index) => /*#__PURE__*/_jsx(GridImage, {
        alt: imageObj.altText,
        src: imageObj.image,
        onLoad: handleImageLoaded(index)
      }, index))
    });
  };

  return /*#__PURE__*/_jsx(AnimatedMessaging, {
    loaded: imagesLoaded,
    children: /*#__PURE__*/_jsx(BaseMessageCaption, {
      messageKey: messageKey,
      children: getGrid()
    })
  });
};